import React, {useEffect} from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import Icon from "material-ui/Icon";
import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";
import styles from "./styles";

const NotesModal = (props) => {
    const nodeName = props.nodeName;
    const isOpen = props.isOpen;
    const showHideNotesModal = props.showHideNotesModal;
    const onNotesClose = props.onNotesClose;
    const classes = props.classes;
    const translate = props.translate;

    const closeNotesModal = () => showHideNotesModal(false);
    const [note, setNote] = React.useState(props.originalNote);
    function onNoteChange(e) {
        setNote(e.target.value);
    }

    function saveNodeModal() {
        closeNotesModal();
        onNotesClose(note);
    }

    return (
        <Modal open={isOpen}>
            <div className={classes.root}> 
            <form noValidate autoComplete="off">
                <Paper className={classes.modal}>
                    <ModalHeader>
                        <Typography type="subheading" color="inherit" className={classes.flex}>
                            {translate("result_usernotes")}
                        </Typography>
                        <Button className={classes.button} onClick={closeNotesModal}>
                            <Icon>clear</Icon>
                        </Button>
                    </ModalHeader>
                    <ModalContents>
                        <textarea autoFocus cols="100" rows="20" onChange={onNoteChange} value={note} maxLength="5016" style={{maxWidth:'900px', maxHeight:'700px'}}  />
                    </ModalContents>
                    <ModalFooter classes={classes}>
                      <Button className={classes.submit} raised color="accent" type="submit" onClick={saveNodeModal}>
                        {translate("sub_set_ping_save_target")}
                      </Button>
            </ModalFooter>
                </Paper>
                </form>
            </div>
        </Modal>
    );
};

export default withStyles(styles)(NotesModal);